import PDSFlexBox from 'designSystem/components/PDSFlexBox/PDSFlexBox'
import PDSIcon from 'designSystem/components/PDSIcon/PDSIcon'
import PDSText from 'designSystem/components/PDSText/PDSText'
import { COLOR } from 'designSystem/foundations/constants/color'
import { FONT_SIZE } from 'designSystem/foundations/constants/fontSize'
import { SIZE } from 'designSystem/foundations/constants/size'

type Props = {
  isOpen: boolean
}

export default function FactorTiltsCollapsibleTrigger({ isOpen }: Props) {
  return (
    <PDSFlexBox
      flexDirection="row"
      marginBottom={SIZE.s8}
      gap={SIZE.s8}
      alignItems="center"
    >
      <PDSIcon name="settings" size="sm" color={COLOR.textAction} />
      <PDSText
        color={COLOR.textAction}
        variant="p"
        fontSize={FONT_SIZE.xs}
        fontWeight={600}
      >
        Advanced Settings
      </PDSText>
      <PDSIcon
        name={isOpen ? 'chevronDown' : 'chevronUp'}
        size="sm"
        color={COLOR.textAction}
      />
    </PDSFlexBox>
  )
}
